import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';

import {ActivatedRoute, Router} from "@angular/router";
import {MenuItem} from "primeng/api";
import {
    OverviewStatisticsBaseComponent
} from "../../../../../../core/shared/overview/overview-statistics-base.component";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {OverviewDto} from "../../../../../../core/shared/overview/dto/overview.dto";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../../core/shared/widget/widget-data-param";
import {ObjectRequestListGroupBy} from "../../../../../../core/shared/dto/object/request/object-request-list-group-by";
import {
    ObjectRequestListAttribute
} from "../../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";
import {Sorting} from "../../../../../../core/shared/misc/sorting";


@Component({
    selector: 'pm-statistics-component',
    templateUrl: 'pm-statistics.component.html',
    standalone: false
})
export class PmStatisticsComponent extends OverviewStatisticsBaseComponent implements OnInit, OnChanges, OnDestroy {


    busyCalls: number = 0;
    no_answerCalls: number = 0;
    no_timeCalls: number = 0;
    successCalls: number = 0;


    personHistoryWidget: WidgetData;
    personTypeWidget: WidgetData;
    personGenderWidget: WidgetData;
    recentPersonsWidget: WidgetData;

    items: MenuItem[] | undefined;

    home: MenuItem | undefined;
    overviewDto: OverviewDto[];

    constructor(
        private router: Router,
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService) {
        super(route, coreService)
    }

    ngOnInit(): void {


        this.items = [
            {label: 'Person Module'},
        ];

        this.home = {icon: 'pi pi-home', routerLink: '/'};
        super.ngOnInit();
        this.initComponent();
        this.overviewDto = [
            {label: 'Busy', value: 0},
            {label: 'No answer', value: 0},
            {label: 'No time', value: 0},
            {label: 'Success', value: 0}
        ];
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {

        this.refreshPersonHistoryWidget();
        this.refreshPersonTypeWidget();
        this.refreshPersonGenderWidget();
        this.refreshRecentPersonsWidget();
        this.initialized = true;
    }

    navigateToConfig() {
        this.router.navigate(['/pm/config']);
    }

    refreshPersonHistoryWidget() {
        this.personHistoryWidget = WidgetFactory.createWidget(
            'pm.overview.person.history.widget',
            'Person Hisory',
            'history.chart',
            'list',
            'entity.groupBy',
            'pc.Call',
            WidgetDataParam.create("fieldCategory", "callType"),
            WidgetDataParam.create("fieldCategoryCount", "callType_count"),
            WidgetDataParam.create("historyPeriodMode", "month"),
            WidgetDataParam.create("fieldDate", "createdDate"),
            WidgetDataParam.create("selectionMode", "single"),
            WidgetDataParam.create("size", "S")
        );
        this.personHistoryWidget.dataProviderListRequest = ObjectRequestListGroupBy.create(
            true,
            this.filterCriteria,
            [],
            ["callType", "createdDate"],
            [new ObjectRequestListAttribute("callType", "Type", DtoListAttributeRequestAggregateEnum.count)]
        );
    }

    refreshPersonTypeWidget() {
        this.personTypeWidget = WidgetFactory.createWidgetGroupBy(
            'pc.overview.call.type.widget',
            'Call Type',
            'category',
            'entity.groupBy',
            'pc.Call',
            'callType',
            'callType_count',
            this.filterCriteria,
            'callType',
            'Anzahl');
    }

    refreshPersonGenderWidget() {
        this.personGenderWidget = WidgetFactory.createWidgetGroupBy(
            'pc.overview.call.agents.widget',
            'Call Agents',
            'category',
            'entity.groupBy',
            'pc.Call',
            'agent',
            'agent_count',
            this.filterCriteria,
            'agent',
            'Anzahl');
    }

    refreshRecentPersonsWidget() {
        this.recentPersonsWidget = WidgetFactory.createWidgetTableEntityBasicQl('pc.overview.recently.calls', 'Recent Calls', 'pc.Call', this.filterCriteriaForQuery ?? [], [new Sorting('e.createdDate', false)]);
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
